import { render, staticRenderFns } from "./BloqueTestimonios.vue?vue&type=template&id=33b176d6&scoped=true"
import script from "./BloqueTestimonios.vue?vue&type=script&lang=js"
export * from "./BloqueTestimonios.vue?vue&type=script&lang=js"
import style0 from "./BloqueTestimonios.vue?vue&type=style&index=0&id=33b176d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b176d6",
  null
  
)

export default component.exports